module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"history":"User Agreement"}}')
  delete Component.options._Ctor
}
